import { useSyncExternalStore } from 'react';
import { type ConsentChoice } from './consent';
import { getConsentSnapshot, subscribe } from './consentStore';

/**
 * The visitor's analytics decision, or `null` while they have not made one.
 *
 * Re-renders the caller when the decision changes, wherever it was changed from - the
 * banner and the privacy page both write to the same store.
 */
export function useConsent(): ConsentChoice | null {
  return useSyncExternalStore(subscribe, getConsentSnapshot, getConsentSnapshot);
}
